import { render } from "./contentsDetailView.vue?vue&type=template&id=6b094ae0"
import script from "./contentsDetailView.vue?vue&type=script&lang=js"
export * from "./contentsDetailView.vue?vue&type=script&lang=js"

import exportComponent from "D:\\workspace\\eduwind-front\\eduwind-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__